import React, { MouseEvent, memo, useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import { SurfaceButtonProps } from './SurfaceButton.types'

const SurfaceButton = ({
    text,
    icon,
    variant,
    onClick,
    path,
    disabled,
    builder,
}: SurfaceButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const hasClicked = useCallback(
        (event: MouseEvent<HTMLElement>) => {
            if (builder) {
                event.preventDefault()
                setAnchorEl(event.currentTarget)
            } else if (onClick) {
                onClick(event)
            }
        },
        [onClick, builder, setAnchorEl]
    )

    if (onClick || builder) {
        return (
            <>
                <Button
                    variant={variant === 'primary' ? 'contained' : 'text'}
                    size="medium"
                    color={variant}
                    onClick={hasClicked}
                    startIcon={icon}
                    disabled={disabled}
                >
                    {text}
                </Button>

                {anchorEl &&
                    builder &&
                    builder(anchorEl, () => setAnchorEl(null))}
            </>
        )
    }

    return (
        <Button
            variant={variant === 'primary' ? 'contained' : 'text'}
            size="medium"
            color={variant}
            startIcon={icon}
            component={Link}
            to={path ?? '#'}
            disabled={disabled}
        >
            {text}
        </Button>
    )
}

export default memo(SurfaceButton)
